// request.js
import axios from 'axios'
import store from '@/store';
import apiInterface from "./apiInterface";
import VueCookie from 'vue-cookie'
import md5 from 'js-md5'
import qs from 'qs'
import { Message } from "element-ui";

const domain = process.env.NODE_DOMAIN;
let isOrigin = process.env.NODE_ENV === 'development' ? true : true //控制中间件  true:开启，false:关闭
let ist = false;
let cist = false; // 汇率
let sist = false; // 官方商城token
let aist = false; // 活动token
const interfaceInfo = apiInterface.Interface.info
// 创建 axios 实例
let baseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseUrl = ''
} else if (process.env.NODE_ENV === 'development') {
  baseUrl = ''

}
// 响应时间
axios.defaults.timeout = 30 * 1000;
// 配置cookie
// axios.defaults.withCredentials = true
// 配置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.common['Authorization'] = '1';

// 配置接口地址
//axios.defaults.baseURL = baseUrl;


// var loadingInstance;
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    //console.log(qs.stringify(config.params))
    baseUrl = config.url.split('/')
    //console.log(config.url.indexOf(interfaceInfo.store),'123123',config.url,interfaceInfo.store)
    //console.log(process.env)
    let user_url = interfaceInfo.userinfo.split('/')[3]
    let commodity_url = interfaceInfo.category.split('/')[3]
    let express_url = interfaceInfo.express.split('/')[3]
    let transport_url = interfaceInfo.transport.split('/')[3]
    let world_url = interfaceInfo.worldapi.split('/')[3]
    let cms_url = interfaceInfo.cms.split('/')[3]
    let store_url = interfaceInfo.store.split('/')[2]
    let activity_url = interfaceInfo.activity.split('/')[3]


    let info = apiInterface.Interface.info;
    info = { lag: info.lag, device: info.device, version: info.version,appname:info.appname }
    if (config.method == 'post') {
      let data = config.data;
      if (typeof(data) == 'string') {
        data = qs.parse(data);
        data = Object.assign({}, data, info)
        config.data = qs.stringify(data)
      } else {
        config.data = Object.assign({}, data, info)
      }
    } else if (config.method == 'get') {
      let params = config.params;
      config.params = Object.assign({}, params, info)
    }


    if (config.url.indexOf(interfaceInfo.worldapi)>-1) {
      //Object.assign()
      //
      //console.log(config,'worldapi')
      if (config.url == apiInterface.Interface.UploadImage) {
        //console.log(apiInterface.Interface.UploadImage, "UploadImage")
        return config;
      } else {
        // 中间件

        if (!WorldUSD()) {
          if (!cist) {
            cist = true;
            let refre = new Promise((resolve, reject) => {
              GetWorldUSD(config, resolve, reject);
            })
            return refre;
          }
        }
        //console.log('world-config:', config)
        return config;
      }
    } else if (config.url.indexOf(interfaceInfo.store)>-1) {
      var cookieToken = storeToken();
      //console.log(cookieToken,'storeToken')
      config.headers.Authorization = cookieToken
      return config;

    } else if (config.url.indexOf(interfaceInfo.activity)>-1) {
      var cookieToken = activityToken();
      //console.log(cookieToken,'activityToken')
      config.headers.Authorization = cookieToken
      return config;

    } else if(config.url.indexOf(interfaceInfo.kyc)>-1){
      return config;
    } else {
      //console.log(config,'other')
      if (config.url != apiInterface.Interface.GetToken) {
        var cookieToken = md5('{"appId": "CardHobbyService","appSecret": "CardHobbyService"}');
        config.headers.Authorization = 'Bearer ' + cookieToken
        return config;
      } else {
        return config;
      }
      return config;
    }
    // if (window.localStorage.getItem('token')) {
    //   config.headers.common['Authorization'] = window.localStorage.getItem('token');
    // }
  },
  err => {
    console.log(err)
    return Promise.reject(err);
  },
);
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    return res;
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误(400)'
          break
        case 401:
          error.message = '未授权，请重新登录(401)'
          break
        case 403:
          error.message = '拒绝访问(403)'
          break
        case 404:
          error.message = '请求出错(404)'
          break
        case 408:
          error.message = '请求超时(408)'
          break
        case 500:
          error.message = '服务器错误(500)'
          break
        case 501:
          error.message = '服务未实现(501)'
          break
        case 502:
          error.message = '网络错误(502)'
          break
        case 503:
          error.message = '服务不可用(503)'
          break
        case 504:
          error.message = '网络超时(504)'
          break
        case 505:
          error.message = 'HTTP版本不受支持(505)'
          break
        default:
          error.message = `连接出错(${status})!`
      }
      error.message
    }
    return Promise.reject(error)
  },
);

//判断是否存在token 废弃
function token() {
  var token = VueCookie.get('CardHobbyToken') || '';
  //console.log("checkToken",token);
  return token
}
//判断是否存在token
function storeToken() {
  var token = VueCookie.get('CardHobbyStoreToken') || '';
  //console.log("checkToken",token);
  return token
}
//判断是否存在token
function activityToken() {
  var token = VueCookie.get('CardHobbyActivityToken') || '';
  //console.log("checkToken",token);
  return token
}
//判断是否存在汇率
function WorldUSD() {
  var token = VueCookie.get('CardExchange') || '';
  //console.log("CardExchange",token);
  return token
}
// 获取token  废弃
async function GetToken(config, resolve, reject) {
  axios.post(apiInterface.Interface.GetToken, { "appId": "CardHobbyWeb", "appSecret": "CardHobbyWeb" }).then(res => {
    //console.log(config,1)
    let time = new Date(new Date().getTime() + 1 * 60 * 60 * 1000)
    VueCookie.set('CardHobbyToken', res.data.Data.Token, { expires: time });
    config.headers.Authorization = 'Bearer ' + res.data.Data.Token
    resolve(config)
  })
}

// 获取官方商城token  
async function GetStoreToken(config, resolve, reject) {
  axios.post(apiInterface.Interface.GetStoreToken, { "appid": "gfcomm", "appkey": "ghfw22TYHUR6U" }).then(res => {
    //console.log(config,1)
    let result = res.data
    const domain = process.env.NODE_DOMAIN
    let time = result.Data.Expires
    VueCookie.set('CardHobbyStoreToken', result.Data.Token, { domain: domain, expires: time });
    config.headers.Authorization = result.Data.Token
    resolve(config)
  })
}

// 获取活动token
async function GetActivityToken(config, resolve, reject) {
  axios.post(apiInterface.Interface.GetActivityToken, { "appid": "act", "appkey": "ghfw22TYHUR6U" }).then(res => {
    //console.log(config,1)
    let result = res.data
    const domain = process.env.NODE_DOMAIN
    let time = result.Data.Expires
    VueCookie.set('CardHobbyActivityToken', result.Data.Token, { domain: domain, expires: time });
    config.headers.Authorization = result.Data.Token
    resolve(config)
  })
}

// 获取汇率  旧
function GetWorldUSD(config, resolve, reject) {
  axios.get(apiInterface.Interface.GetUSD).then(res => {
    //console.log(res,1)
    //config.params.token=res.data.Data.Token
    const domain = process.env.NODE_DOMAIN
    let time = new Date(new Date().getTime() + 0.5 * 60 * 60 * 1000)
    let data = { 'u': res.data.data['Usd'], 'c': res.data.data['Additional'] }
    VueCookie.set('CardExchange', JSON.stringify(data), { domain: domain, expires: time });
    //config.headers.Authorization = 'Bearer ' + res.data.Data.Token
    resolve(config)
  })
}

// 获取买家汇率  新
// function GetWorldUSD(config, resolve, reject) {
//   var info = VueCookie.get('CardExchange') || '';
//   var data={memberSource:'US'}
//   if(info){
//     info=JSON.parse(info)
//     data={memberSource:info.MemberSource}
//   }
//   axios.get(apiInterface.Interface.GetExchangeRate, data).then(res => {
//     const domain = process.env.NODE_DOMAIN
//     let time = new Date(new Date().getTime() + 0.5 * 60 * 60 * 1000)
//     let data = { 'u': res.data.data['Usd'], 'c': res.data.data['Additional'] }
//     VueCookie.set('CardExchange', JSON.stringify(data), { domain: domain, expires: time });
//     //config.headers.Authorization = 'Bearer ' + res.data.Data.Token
//     resolve(config)
//   })
// }

// 中间件 废弃
function AccessControlAllowOrigin(config) {
  const info = apiInterface.Interface.info;
  // var lang=VueCookie.get('CardLang')||'en'
  // if(lang=='zh-tw'){
  //   info.lag='zh'
  // }
  if (config.method == 'post') {
    let data = config.data;
    if (typeof(data) == 'string') {
      data = qs.parse(data);
      data = Object.assign({}, data, info)
      config.data = qs.stringify(data)
    } else {
      config.data = Object.assign({}, data, info)
    }
  } else if (config.method == 'get') {
    let params = config.params;
    config.params = Object.assign({}, params, info)
  }
  if (isOrigin) {
    const LOCAL_API_URL = process.env.VUE_APP_LOCAL_API_URL
    let url = config.url
    let method = config.method
    let methodType = method === 'post' ? '/Post' : '/Get'
    let data = '';
    if (method === 'post') {
      if (typeof(config.data) == 'string') {
        data = "url=" + encodeURIComponent(url) + `&ContentType=application/x-www-form-urlencoded` + "&Param=" + encodeURIComponent(config.data)
      } else {
        data = "url=" + encodeURIComponent(url) + `&ContentType=application/json` + "&Param=" + encodeURIComponent(JSON.stringify(config.data))
      }
      config.data = data
      config.url = LOCAL_API_URL + methodType
    } else {
      if (config.params != '') {
        data = url + '?' + qs.stringify(config.params)
        data = '?url=' + encodeURIComponent(data)
      } else {
        data = '?url=' + encodeURIComponent(url)
      }

      config.url = LOCAL_API_URL + methodType + data
      config.params = ''
    }
  }
  return config
}
let freeZe = 0;

function freeze(msg) {
  if (freeZe == 1) {
    Message.error(msg)
    VueCookie.delete("cardUser", { domain: domain });
    //window.location.href = "/";
    window.location.href = "/#/login";
  }
}
// 发送请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        res => {
          var result = res.data.result || res.data.Result
          var msg = res.data.msg || res.data.Msg
          if (result == -1) {
            freeZe++;
            freeze(msg)
          } else {
            resolve(res.data)
          }
        },
        err => {
          reject(err.data)
        }
      )
      .catch(err => {
        reject(err.data)
      });
  });
};
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        var result = res.data.result || res.data.Result
        var msg = res.data.msg || res.data.Msg
        //console.log(result,'result')
        if (result == -1) {
          freeZe++;
          freeze(msg)
        } else {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject(err)
      });
  });
};
// Time out. Please log in again



// WEBPACK FOOTER //
// ./src/api/axiosConfig.js